// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15glM","fullView":"styles_fullView__3AObP"};